import React from 'react';
import { Redirect } from 'react-router-dom';
import AppConstants from '../../appConstants';

// Legacy /gift URL (old paid gifting) now lives at /be-a-matchmaker.
const MatchmakerRedirect = () => (
  <Redirect to={AppConstants.routes.beAMatchmaker} />
);

export default MatchmakerRedirect;
